import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { actions as ThirdPartiesActions } from "reducers/thirdPayment";
import * as i18n from "util/i18n";

export const useTags = (optionThirdParty, positionTab) => {
    const dispatch = useDispatch();
    const [tags, setTags] = useState([]);
    const { filterThirdParties } = useSelector((state) => state.thirdPayment);

    const tagOptionsCommon = () => {
        const tagOptions = {
            status: { id: "status", text: i18n.get("payThirdParties.status.label") },
            dateFrom: { id: "dateRange", text: i18n.get("payThirdParties.dateRange.label") },
            amountFrom: { id: "amountFrom", text: i18n.get("payThirdParties.amountFrom.label") },
            amountTo: { id: "amountTo", text: i18n.get("payThirdParties.amountTo.label") },
        };

        return tagOptions;
    };
    const commonTagOptions = tagOptionsCommon();

    const tagOptions = {
        "thirdPayment.providers": {
            ...commonTagOptions,
            receiver: { id: "providers", text: i18n.get("thirdPayment.providers.label") },
        },
        "thirdPayment.assets": {
            ...commonTagOptions,
            recurrent: { id: "assets", text: i18n.get("thirdPayment.assets.label") },
        },
    };
    useEffect(() => {
        const activeTags = Object.entries(filterThirdParties)
            .filter(
                (activeFilters) =>
                    !activeFilters.includes("") && !activeFilters.includes("TODOS") && !activeFilters.includes(null),
            )
            .map((filter) => filter[0])
            .filter((filterKey) => !!tagOptions[optionThirdParty][filterKey])
            .map((key) => tagOptions[optionThirdParty][key]);

        setTags(activeTags);
    }, [filterThirdParties]);

    const actionDispatch = (filter) => {
        dispatch(ThirdPartiesActions.loadListThirdRequest(filter));
        dispatch(ThirdPartiesActions.setThirdPartiesFilters(filter));
    };

    const handleDelete = (i) => {
        const deletedFilter = tags.find((tag, index) => index === i).id;
        if (
            deletedFilter !== "dateRange" &&
            deletedFilter !== "status" &&
            deletedFilter !== "amountFrom" &&
            deletedFilter !== "amountTo"
        ) {
            const tagFilters = {
                ...filterThirdParties,
                [deletedFilter]: "",
            };
            actionDispatch(tagFilters);
            return;
        }

        if (deletedFilter === "dateRange") {
            const tagFilters = {
                ...filterThirdParties,
                dateFrom: null,
                dateTo: null,
            };
            actionDispatch(tagFilters);
            return;
        }
        if (deletedFilter === "status") {
            const tagFilters = {
                ...filterThirdParties,
                status: "TODOS",
            };
            actionDispatch(tagFilters);
            return;
        }
        if (deletedFilter === "amountFrom") {
            const tagFilters = {
                ...filterThirdParties,
                amountFrom: "",
            };
            actionDispatch(tagFilters);
        }

        if (deletedFilter === "amountTo") {
            const tagFilters = {
                ...filterThirdParties,
                amountTo: "",
            };
            actionDispatch(tagFilters);
        }
    };
    const handleCleanFilters = () => {
        const clearFilters = {
            ...filterThirdParties,
            dateFrom: null,
            dateTo: null,
            amountTo: "",
            amountFrom: "",
            status: "TODOS",
            typePayment: positionTab === 0 ? "PP" : "PH",
        };
        actionDispatch(clearFilters);
    };

    return { tags, handleDelete, handleCleanFilters };
};

export default useTags;
